<template>
    <div id="app" :class="currentRouteName">
        <Modal />
        <HcpAdhdPopup />

        <irsh-header></irsh-header>
        <router-view class="page"></router-view>
        <div>

            <div>
                <irsh-widget></irsh-widget>
            </div>

            <div class="isi-wrapper">
                <irsh-indication id="indication"></irsh-indication>
            </div>

        </div>

        <irsh-footer></irsh-footer>

        <!-- Floating Interactive ISI Tuner -->
        <IsiTuner />
    </div>
</template>

<script>
import Modal from "./components/global/Modal.vue";
import ShortageModal from "./components/global/ShortageModal.vue";
import HcpAdhdPopup from "./components/global/HcpAdhdPopup.vue";
import Header from './components/global/Header';
import Footer from './components/global/Footer';
import Settings from './components/global/Settings.vue';
import dataList from "./models/dataList";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            currentRouteName: null,
            pages: dataList.pages()
        }
    },
    components: {
        "irsh-header": Header,
        "irsh-footer": Footer,
        Modal,
        ShortageModal,
        HcpAdhdPopup,
        Settings,
        IsiTuner: Settings
    },
    watch: {

        '$route': function (e) {

            this.currentRouteName = this.$router.currentRoute.name
            this.setHeaderClasses('')
            if (e) {
                this.$root.$emit('change-text')
                this.$root.$emit('close-nav')
                this.$root.$emit('is-widget')
            }
        }
    },
    created() {
        this.currentRouteName = this.$router.currentRoute.name
    },
    mounted() {
        const nav = this.$router.currentRoute.meta.nav;
        if (nav) {
            document.querySelector('a[data-link-active="' + nav + '"]').classList.add('active')

            // Update canonical
            document.querySelector('[rel="canonical"]').setAttribute('href', this.$router.currentRoute.meta.canonical)
        }

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: [0],
        };

        let callback = (entries, observer) => {
            entries.forEach((entry) => {
                // changing opacity of element based on its visibility on the viewport

                if (entry.isIntersecting) {
                    entry.target.classList.add('active')
                }
            });
        };

        let observer = new IntersectionObserver(callback, options);



        var highlights = document.getElementsByClassName('highlight');


        for (var el in highlights) {

            observer.observe(highlights[el]);
        }
    },
    computed: {
        pagesWithSmallImage() {
            return this.pages.filter(p => this.hasSmallImage(p))
        },
        ...mapGetters(['headerClasses'])
    },
    methods: {
        getPageImage(page) {
            const images = page.images
            if (images == null) return ''
            return Array.isArray(images) && images.length ? images[0] : images
        },
        getSmallPageImage(page) {
            const images = page.images
            if (images == null) return ''
            return Array.isArray(images) && images.length > 1 ? images[1] : ''
        },
        hasSmallImage(page) {
            const images = page.images
            return images != null && Array.isArray(images) && images.length > 1
        },
        ...mapActions(["setHeaderClasses"])
    }
}
</script>
<style lang="scss">
    @import './assets/fonts/Omnes/Omnes.css';
    @import './assets/fonts/ProximaNova/ProximaNova.css';
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=swap');
</style>
